import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
}

function FaqItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-100 last:border-b-0">
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        className="flex w-full items-center justify-between py-4 text-left transition-colors hover:text-gray-700"
      >
        <span className="pr-4 text-sm font-semibold text-gray-900">{question}</span>
        <svg
          className={`size-4 shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div
        className={`grid transition-all duration-200 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
      >
        <div className="overflow-hidden">
          <div className="pr-8 pb-4 text-sm text-gray-600">{answer}</div>
        </div>
      </div>
    </div>
  );
}

export { FaqItem };
